import { type SDK_WriteUserRecordMutationVariables, clientConfig, getSdk } from "@quickpoint.me/shared";
import { GraphQLClient } from "graphql-request";
import { nanoid } from "nanoid";
import { withAttributionUtms } from "../../../lib/conversionTracking";
import { rybbitPageview } from "../../../lib/rybbit";

export const uploadRecord = async (value: string) => {
    const record: SDK_WriteUserRecordMutationVariables = {
        created: Date.now(),
        id: nanoid(26),
        stackId: "register",
        recordType: "email",
        stack: "quickpoint/landing",
        value,
    };


    const client = new GraphQLClient(clientConfig.gqlWriteUserRecord());
    const sdk = getSdk(client);
    try {
        await sdk.WriteUserRecord(record);
        // Attribute the signup to Rybbit with utm_medium=signup, backfilling
        // campaign UTMs from the qp_attr cookie when the landing URL didn't
        // carry them (init-gated pageview so it isn't dropped).
        const savedQuery = sessionStorage.getItem("queryString") ?? "";
        const params = new URLSearchParams(withAttributionUtms(savedQuery));
        params.set("utm_medium", "signup");
        rybbitPageview(
            `${window.location.origin}${window.location.pathname}?${params.toString()}`,
        );
        sessionStorage.removeItem("queryString");

        return true
    } catch (e) {
        console.log(e)
        return false
    }
};